// Country-Language Mapping Database
// Maps country codes to supported languages with their WordPress category IDs

export interface LanguagePreference {
  language_code: string;
  language_id: string;
}

export interface CountryLanguageInfo {
  country_code: string;
  languages: LanguagePreference[];
}

export const countryLanguageMapping: Record<string, CountryLanguageInfo> = {
  "AF": {
    "country_code": "AF",
    "languages": [
      { "language_code": "fa", "language_id": "13983" },
      { "language_code": "ps", "language_id": "14027" }
    ]
  },
  "AL": {
    "country_code": "AL",
    "languages": [
      { "language_code": "sq", "language_id": "14041" }
    ]
  },
  "DZ": {
    "country_code": "DZ",
    "languages": [
      { "language_code": "ar", "language_id": "13963" },
      { "language_code": "ber", "language_id": "13967" }
    ]
  },
  "AD": {
    "country_code": "AD",
    "languages": [
      { "language_code": "ca", "language_id": "13972" }
    ]
  },
  "AO": {
    "country_code": "AO",
    "languages": [
      { "language_code": "pt", "language_id": "14028" }
    ]
  },
  "AG": {
    "country_code": "AG",
    "languages": [
      { "language_code": "en", "language_id": "11703" }
    ]
  },
  "AR": {
    "country_code": "AR",
    "languages": [
      { "language_code": "es", "language_id": "13981" }
    ]
  },
  "AM": {
    "country_code": "AM",
    "languages": [
      { "language_code": "hy", "language_id": "13997" }
    ]
  },
  "AU": {
    "country_code": "AU",
    "languages": [
      { "language_code": "en", "language_id": "11703" }
    ]
  },
  "AT": {
    "country_code": "AT",
    "languages": [
      { "language_code": "de", "language_id": "13977" }
    ]
  },
  "AZ": {
    "country_code": "AZ",
    "languages": [
      { "language_code": "az", "language_id": "13965" }
    ]
  },
  "BS": {
    "country_code": "BS",
    "languages": [
      { "language_code": "en", "language_id": "11703" }
    ]
  },
  "BH": {
    "country_code": "BH",
    "languages": [
      { "language_code": "ar", "language_id": "13963" }
    ]
  },
  "BD": {
    "country_code": "BD",
    "languages": [
      { "language_code": "bn", "language_id": "13970" }
    ]
  },
  "BB": {
    "country_code": "BB",
    "languages": [
      { "language_code": "en", "language_id": "11703" }
    ]
  },
  "BY": {
    "country_code": "BY",
    "languages": [
      { "language_code": "be", "language_id": "13966" },
      { "language_code": "ru", "language_id": "14033" }
    ]
  },
  "BE": {
    "country_code": "BE",
    "languages": [
      { "language_code": "nl", "language_id": "14022" },
      { "language_code": "fr", "language_id": "13987" },
      { "language_code": "de", "language_id": "13977" }
    ]
  },
  "BZ": {
    "country_code": "BZ",
    "languages": [
      { "language_code": "en", "language_id": "11703" }
    ]
  },
  "BJ": {
    "country_code": "BJ",
    "languages": [
      { "language_code": "fr", "language_id": "13987" }
    ]
  },
  "BT": {
    "country_code": "BT",
    "languages": [
      { "language_code": "dz", "language_id": "13979" }
    ]
  },
  "BO": {
    "country_code": "BO",
    "languages": [
      { "language_code": "es", "language_id": "13981" },
      { "language_code": "qu", "language_id": "14029" },
      { "language_code": "ay", "language_id": "13964" }
    ]
  },
  "BA": {
    "country_code": "BA",
    "languages": [
      { "language_code": "bs", "language_id": "13971" },
      { "language_code": "hr", "language_id": "13994" },
      { "language_code": "sr", "language_id": "14042" }
    ]
  },
  "BW": {
    "country_code": "BW",
    "languages": [
      { "language_code": "en", "language_id": "11703" },
      { "language_code": "tn", "language_id": "14053" }
    ]
  },
  "BR": {
    "country_code": "BR",
    "languages": [
      { "language_code": "pt", "language_id": "14028" }
    ]
  },
  "BN": {
    "country_code": "BN",
    "languages": [
      { "language_code": "ms", "language_id": "14017" }
    ]
  },
  "BG": {
    "country_code": "BG",
    "languages": [
      { "language_code": "bg", "language_id": "13968" }
    ]
  },
  "BF": {
    "country_code": "BF",
    "languages": [
      { "language_code": "fr", "language_id": "13987" }
    ]
  },
  "BI": {
    "country_code": "BI",
    "languages": [
      { "language_code": "rn", "language_id": "14031" },
      { "language_code": "fr", "language_id": "13987" },
      { "language_code": "en", "language_id": "11703" }
    ]
  },
  "CV": {
    "country_code": "CV",
    "languages": [
      { "language_code": "pt", "language_id": "14028" }
    ]
  },
  "KH": {
    "country_code": "KH",
    "languages": [
      { "language_code": "km", "language_id": "14004" }
    ]
  },
  "CM": {
    "country_code": "CM",
    "languages": [
      { "language_code": "fr", "language_id": "13987" },
      { "language_code": "en", "language_id": "11703" }
    ]
  },
  "CA": {
    "country_code": "CA",
    "languages": [
      { "language_code": "en", "language_id": "11703" },
      { "language_code": "fr", "language_id": "13987" }
    ]
  },
  "CF": {
    "country_code": "CF",
    "languages": [
      { "language_code": "fr", "language_id": "13987" },
      { "language_code": "sg", "language_id": "14035" }
    ]
  },
  "TD": {
    "country_code": "TD",
    "languages": [
      { "language_code": "fr", "language_id": "13987" },
      { "language_code": "ar", "language_id": "13963" }
    ]
  },
  "CL": {
    "country_code": "CL",
    "languages": [
      { "language_code": "es", "language_id": "13981" }
    ]
  },
  "CN": {
    "country_code": "CN",
    "languages": [
      { "language_code": "zh", "language_id": "14063" }
    ]
  },
  "CO": {
    "country_code": "CO",
    "languages": [
      { "language_code": "es", "language_id": "13981" }
    ]
  },
  "KM": {
    "country_code": "KM",
    "languages": [
      { "language_code": "ar", "language_id": "13963" },
      { "language_code": "fr", "language_id": "13987" },
      { "language_code": "zdj", "language_id": "14062" }
    ]
  },
  "CR": {
    "country_code": "CR",
    "languages": [
      { "language_code": "es", "language_id": "13981" }
    ]
  },
  "HR": {
    "country_code": "HR",
    "languages": [
      { "language_code": "hr", "language_id": "13994" }
    ]
  },
  "CU": {
    "country_code": "CU",
    "languages": [
      { "language_code": "es", "language_id": "13981" }
    ]
  },
  "CY": {
    "country_code": "CY",
    "languages": [
      { "language_code": "el", "language_id": "13980" },
      { "language_code": "tr", "language_id": "14056" }
    ]
  },
  "CZ": {
    "country_code": "CZ",
    "languages": [
      { "language_code": "cs", "language_id": "13975" }
    ]
  },
  "CD": {
    "country_code": "CD",
    "languages": [
      { "language_code": "fr", "language_id": "13987" }
    ]
  },
  "DK": {
    "country_code": "DK",
    "languages": [
      { "language_code": "da", "language_id": "13976" }
    ]
  },
  "DJ": {
    "country_code": "DJ",
    "languages": [
      { "language_code": "fr", "language_id": "13987" },
      { "language_code": "ar", "language_id": "13963" }
    ]
  },
  "DM": {
    "country_code": "DM",
    "languages": [
      { "language_code": "en", "language_id": "11703" }
    ]
  },
  "DO": {
    "country_code": "DO",
    "languages": [
      { "language_code": "es", "language_id": "13981" }
    ]
  },
  "EC": {
    "country_code": "EC",
    "languages": [
      { "language_code": "es", "language_id": "13981" }
    ]
  },
  "EG": {
    "country_code": "EG",
    "languages": [
      { "language_code": "ar", "language_id": "13963" }
    ]
  },
  "SV": {
    "country_code": "SV",
    "languages": [
      { "language_code": "es", "language_id": "13981" }
    ]
  },
  "GQ": {
    "country_code": "GQ",
    "languages": [
      { "language_code": "es", "language_id": "13981" },
      { "language_code": "fr", "language_id": "13987" },
      { "language_code": "pt", "language_id": "14028" }
    ]
  },
  "ER": {
    "country_code": "ER",
    "languages": [
      { "language_code": "ti", "language_id": "14051" },
      { "language_code": "ar", "language_id": "13963" },
      { "language_code": "en", "language_id": "11703" }
    ]
  },
  "EE": {
    "country_code": "EE",
    "languages": [
      { "language_code": "et", "language_id": "13982" }
    ]
  },
  "SZ": {
    "country_code": "SZ",
    "languages": [
      { "language_code": "en", "language_id": "11703" },
      { "language_code": "ss", "language_id": "14043" }
    ]
  },
  "ET": {
    "country_code": "ET",
    "languages": [
      { "language_code": "am", "language_id": "13960" }
    ]
  },
  "FJ": {
    "country_code": "FJ",
    "languages": [
      { "language_code": "en", "language_id": "11703" },
      { "language_code": "fj", "language_id": "13986" },
      { "language_code": "hi", "language_id": "13992" }
    ]
  },
  "FI": {
    "country_code": "FI",
    "languages": [
      { "language_code": "fi", "language_id": "13984" },
      { "language_code": "sv", "language_id": "14045" }
    ]
  },
  "FR": {
    "country_code": "FR",
    "languages": [
      { "language_code": "fr", "language_id": "13987" }
    ]
  },
  "GA": {
    "country_code": "GA",
    "languages": [
      { "language_code": "fr", "language_id": "13987" }
    ]
  },
  "GM": {
    "country_code": "GM",
    "languages": [
      { "language_code": "en", "language_id": "11703" }
    ]
  },
  "GE": {
    "country_code": "GE",
    "languages": [
      { "language_code": "ka", "language_id": "14002" }
    ]
  },
  "DE": {
    "country_code": "DE",
    "languages": [
      { "language_code": "de", "language_id": "13977" }
    ]
  },
  "GH": {
    "country_code": "GH",
    "languages": [
      { "language_code": "en", "language_id": "11703" }
    ]
  },
  "GR": {
    "country_code": "GR",
    "languages": [
      { "language_code": "el", "language_id": "13980" }
    ]
  },
  "GD": {
    "country_code": "GD",
    "languages": [
      { "language_code": "en", "language_id": "11703" }
    ]
  },
  "GT": {
    "country_code": "GT",
    "languages": [
      { "language_code": "es", "language_id": "13981" }
    ]
  },
  "GN": {
    "country_code": "GN",
    "languages": [
      { "language_code": "fr", "language_id": "13987" }
    ]
  },
  "GW": {
    "country_code": "GW",
    "languages": [
      { "language_code": "pt", "language_id": "14028" }
    ]
  },
  "GY": {
    "country_code": "GY",
    "languages": [
      { "language_code": "en", "language_id": "11703" }
    ]
  },
  "HT": {
    "country_code": "HT",
    "languages": [
      { "language_code": "fr", "language_id": "13987" },
      { "language_code": "ht", "language_id": "13995" }
    ]
  },
  "HN": {
    "country_code": "HN",
    "languages": [
      { "language_code": "es", "language_id": "13981" }
    ]
  },
  "HU": {
    "country_code": "HU",
    "languages": [
      { "language_code": "hu", "language_id": "13996" }
    ]
  },
  "IS": {
    "country_code": "IS",
    "languages": [
      { "language_code": "is", "language_id": "13999" }
    ]
  },
  "IN": {
    "country_code": "IN",
    "languages": [
      { "language_code": "hi", "language_id": "13992" },
      { "language_code": "en", "language_id": "11703" }
    ]
  },
  "ID": {
    "country_code": "ID",
    "languages": [
      { "language_code": "id", "language_id": "13998" }
    ]
  },
  "IR": {
    "country_code": "IR",
    "languages": [
      { "language_code": "fa", "language_id": "13983" }
    ]
  },
  "IQ": {
    "country_code": "IQ",
    "languages": [
      { "language_code": "ar", "language_id": "13963" },
      { "language_code": "ku", "language_id": "14006" }
    ]
  },
  "IE": {
    "country_code": "IE",
    "languages": [
      { "language_code": "ga", "language_id": "13988" },
      { "language_code": "en", "language_id": "11703" }
    ]
  },
  "IL": {
    "country_code": "IL",
    "languages": [
      { "language_code": "he", "language_id": "13991" },
      { "language_code": "ar", "language_id": "13963" }
    ]
  },
  "IT": {
    "country_code": "IT",
    "languages": [
      { "language_code": "it", "language_id": "14000" }
    ]
  },
  "CI": {
    "country_code": "CI",
    "languages": [
      { "language_code": "fr", "language_id": "13987" }
    ]
  },
  "JM": {
    "country_code": "JM",
    "languages": [
      { "language_code": "en", "language_id": "11703" }
    ]
  },
  "JP": {
    "country_code": "JP",
    "languages": [
      { "language_code": "ja", "language_id": "14001" }
    ]
  },
  "JO": {
    "country_code": "JO",
    "languages": [
      { "language_code": "ar", "language_id": "13963" }
    ]
  },
  "KZ": {
    "country_code": "KZ",
    "languages": [
      { "language_code": "kk", "language_id": "14003" },
      { "language_code": "ru", "language_id": "14033" }
    ]
  },
  "KE": {
    "country_code": "KE",
    "languages": [
      { "language_code": "en", "language_id": "11703" },
      { "language_code": "sw", "language_id": "14046" }
    ]
  },
  "KI": {
    "country_code": "KI",
    "languages": [
      { "language_code": "en", "language_id": "11703" },
      { "language_code": "gil", "language_id": "13989" }
    ]
  },
  "KW": {
    "country_code": "KW",
    "languages": [
      { "language_code": "ar", "language_id": "13963" }
    ]
  },
  "KG": {
    "country_code": "KG",
    "languages": [
      { "language_code": "ky", "language_id": "14007" },
      { "language_code": "ru", "language_id": "14033" }
    ]
  },
  "LA": {
    "country_code": "LA",
    "languages": [
      { "language_code": "lo", "language_id": "14009" }
    ]
  },
  "LV": {
    "country_code": "LV",
    "languages": [
      { "language_code": "lv", "language_id": "14011" }
    ]
  },
  "LB": {
    "country_code": "LB",
    "languages": [
      { "language_code": "ar", "language_id": "13963" }
    ]
  },
  "LS": {
    "country_code": "LS",
    "languages": [
      { "language_code": "st", "language_id": "14044" },
      { "language_code": "en", "language_id": "11703" }
    ]
  },
  "LR": {
    "country_code": "LR",
    "languages": [
      { "language_code": "en", "language_id": "11703" }
    ]
  },
  "LY": {
    "country_code": "LY",
    "languages": [
      { "language_code": "ar", "language_id": "13963" }
    ]
  },
  "LI": {
    "country_code": "LI",
    "languages": [
      { "language_code": "de", "language_id": "13977" }
    ]
  },
  "LT": {
    "country_code": "LT",
    "languages": [
      { "language_code": "lt", "language_id": "14010" }
    ]
  },
  "LU": {
    "country_code": "LU",
    "languages": [
      { "language_code": "lb", "language_id": "14008" },
      { "language_code": "fr", "language_id": "13987" },
      { "language_code": "de", "language_id": "13977" }
    ]
  },
  "MG": {
    "country_code": "MG",
    "languages": [
      { "language_code": "mg", "language_id": "14012" },
      { "language_code": "fr", "language_id": "13987" }
    ]
  },
  "MW": {
    "country_code": "MW",
    "languages": [
      { "language_code": "en", "language_id": "11703" },
      { "language_code": "ny", "language_id": "14024" }
    ]
  },
  "MY": {
    "country_code": "MY",
    "languages": [
      { "language_code": "ms", "language_id": "14017" }
    ]
  },
  "MV": {
    "country_code": "MV",
    "languages": [
      { "language_code": "dv", "language_id": "13978" }
    ]
  },
  "ML": {
    "country_code": "ML",
    "languages": [
      { "language_code": "fr", "language_id": "13987" }
    ]
  },
  "MT": {
    "country_code": "MT",
    "languages": [
      { "language_code": "mt", "language_id": "14018" },
      { "language_code": "en", "language_id": "11703" }
    ]
  },
  "MH": {
    "country_code": "MH",
    "languages": [
      { "language_code": "mh", "language_id": "14013" },
      { "language_code": "en", "language_id": "11703" }
    ]
  },
  "MR": {
    "country_code": "MR",
    "languages": [
      { "language_code": "ar", "language_id": "13963" }
    ]
  },
  "MU": {
    "country_code": "MU",
    "languages": [
      { "language_code": "en", "language_id": "11703" },
      { "language_code": "fr", "language_id": "13987" }
    ]
  },
  "MX": {
    "country_code": "MX",
    "languages": [
      { "language_code": "es", "language_id": "13981" }
    ]
  },
  "FM": {
    "country_code": "FM",
    "languages": [
      { "language_code": "en", "language_id": "11703" }
    ]
  },
  "MD": {
    "country_code": "MD",
    "languages": [
      { "language_code": "ro", "language_id": "14032" }
    ]
  },
  "MC": {
    "country_code": "MC",
    "languages": [
      { "language_code": "fr", "language_id": "13987" }
    ]
  },
  "MN": {
    "country_code": "MN",
    "languages": [
      { "language_code": "mn", "language_id": "14016" }
    ]
  },
  "ME": {
    "country_code": "ME",
    "languages": [
      { "language_code": "cnr", "language_id": "13973" }
    ]
  },
  "MA": {
    "country_code": "MA",
    "languages": [
      { "language_code": "ar", "language_id": "13963" },
      { "language_code": "ber", "language_id": "13967" }
    ]
  },
  "MZ": {
    "country_code": "MZ",
    "languages": [
      { "language_code": "pt", "language_id": "14028" }
    ]
  },
  "MM": {
    "country_code": "MM",
    "languages": [
      { "language_code": "my", "language_id": "14019" }
    ]
  },
  "NA": {
    "country_code": "NA",
    "languages": [
      { "language_code": "en", "language_id": "11703" }
    ]
  },
  "NR": {
    "country_code": "NR",
    "languages": [
      { "language_code": "na", "language_id": "14020" },
      { "language_code": "en", "language_id": "11703" }
    ]
  },
  "NP": {
    "country_code": "NP",
    "languages": [
      { "language_code": "ne", "language_id": "14021" }
    ]
  },
  "NL": {
    "country_code": "NL",
    "languages": [
      { "language_code": "nl", "language_id": "14022" }
    ]
  },
  "NZ": {
    "country_code": "NZ",
    "languages": [
      { "language_code": "en", "language_id": "11703" },
      { "language_code": "mi", "language_id": "14014" }
    ]
  },
  "NI": {
    "country_code": "NI",
    "languages": [
      { "language_code": "es", "language_id": "13981" }
    ]
  },
  "NE": {
    "country_code": "NE",
    "languages": [
      { "language_code": "fr", "language_id": "13987" }
    ]
  },
  "NG": {
    "country_code": "NG",
    "languages": [
      { "language_code": "en", "language_id": "11703" }
    ]
  },
  "KP": {
    "country_code": "KP",
    "languages": [
      { "language_code": "ko", "language_id": "14005" }
    ]
  },
  "MK": {
    "country_code": "MK",
    "languages": [
      { "language_code": "mk", "language_id": "14015" }
    ]
  },
  "NO": {
    "country_code": "NO",
    "languages": [
      { "language_code": "no", "language_id": "14023" }
    ]
  },
  "OM": {
    "country_code": "OM",
    "languages": [
      { "language_code": "ar", "language_id": "13963" }
    ]
  },
  "PK": {
    "country_code": "PK",
    "languages": [
      { "language_code": "ur", "language_id": "14059" },
      { "language_code": "en", "language_id": "11703" }
    ]
  },
  "PW": {
    "country_code": "PW",
    "languages": [
      { "language_code": "pau", "language_id": "14025" },
      { "language_code": "en", "language_id": "11703" }
    ]
  },
  "PA": {
    "country_code": "PA",
    "languages": [
      { "language_code": "es", "language_id": "13981" }
    ]
  },
  "PG": {
    "country_code": "PG",
    "languages": [
      { "language_code": "en", "language_id": "11703" },
      { "language_code": "tpi", "language_id": "14055" },
      { "language_code": "ho", "language_id": "13993" }
    ]
  },
  "PY": {
    "country_code": "PY",
    "languages": [
      { "language_code": "es", "language_id": "13981" },
      { "language_code": "gn", "language_id": "13990" }
    ]
  },
  "PE": {
    "country_code": "PE",
    "languages": [
      { "language_code": "es", "language_id": "13981" },
      { "language_code": "qu", "language_id": "14029" }
    ]
  },
  "PH": {
    "country_code": "PH",
    "languages": [
      { "language_code": "fil", "language_id": "13985" },
      { "language_code": "en", "language_id": "11703" }
    ]
  },
  "PL": {
    "country_code": "PL",
    "languages": [
      { "language_code": "pl", "language_id": "14026" }
    ]
  },
  "PT": {
    "country_code": "PT",
    "languages": [
      { "language_code": "pt", "language_id": "14028" }
    ]
  },
  "QA": {
    "country_code": "QA",
    "languages": [
      { "language_code": "ar", "language_id": "13963" }
    ]
  },
  "CG": {
    "country_code": "CG",
    "languages": [
      { "language_code": "fr", "language_id": "13987" }
    ]
  },
  "RO": {
    "country_code": "RO",
    "languages": [
      { "language_code": "ro", "language_id": "14032" }
    ]
  },
  "RU": {
    "country_code": "RU",
    "languages": [
      { "language_code": "ru", "language_id": "14033" }
    ]
  },
  "RW": {
    "country_code": "RW",
    "languages": [
      { "language_code": "rw", "language_id": "14034" },
      { "language_code": "fr", "language_id": "13987" },
      { "language_code": "en", "language_id": "11703" },
      { "language_code": "sw", "language_id": "14046" }
    ]
  },
  "KN": {
    "country_code": "KN",
    "languages": [
      { "language_code": "en", "language_id": "11703" }
    ]
  },
  "LC": {
    "country_code": "LC",
    "languages": [
      { "language_code": "en", "language_id": "11703" }
    ]
  },
  "VC": {
    "country_code": "VC",
    "languages": [
      { "language_code": "en", "language_id": "11703" }
    ]
  },
  "WS": {
    "country_code": "WS",
    "languages": [
      { "language_code": "sm", "language_id": "14039" },
      { "language_code": "en", "language_id": "11703" }
    ]
  },
  "SM": {
    "country_code": "SM",
    "languages": [
      { "language_code": "it", "language_id": "14000" }
    ]
  },
  "ST": {
    "country_code": "ST",
    "languages": [
      { "language_code": "pt", "language_id": "14028" }
    ]
  },
  "SA": {
    "country_code": "SA",
    "languages": [
      { "language_code": "ar", "language_id": "13963" }
    ]
  },
  "SN": {
    "country_code": "SN",
    "languages": [
      { "language_code": "fr", "language_id": "13987" }
    ]
  },
  "RS": {
    "country_code": "RS",
    "languages": [
      { "language_code": "sr", "language_id": "14042" }
    ]
  },
  "SC": {
    "country_code": "SC",
    "languages": [
      { "language_code": "en", "language_id": "11703" },
      { "language_code": "fr", "language_id": "13987" },
      { "language_code": "crs", "language_id": "13974" }
    ]
  },
  "SL": {
    "country_code": "SL",
    "languages": [
      { "language_code": "en", "language_id": "11703" }
    ]
  },
  "SG": {
    "country_code": "SG",
    "languages": [
      { "language_code": "en", "language_id": "11703" },
      { "language_code": "ms", "language_id": "14017" },
      { "language_code": "zh", "language_id": "14063" },
      { "language_code": "ta", "language_id": "14047" }
    ]
  },
  "SK": {
    "country_code": "SK",
    "languages": [
      { "language_code": "sk", "language_id": "14037" }
    ]
  },
  "SI": {
    "country_code": "SI",
    "languages": [
      { "language_code": "sl", "language_id": "14038" }
    ]
  },
  "SB": {
    "country_code": "SB",
    "languages": [
      { "language_code": "en", "language_id": "11703" }
    ]
  },
  "SO": {
    "country_code": "SO",
    "languages": [
      { "language_code": "so", "language_id": "14040" },
      { "language_code": "ar", "language_id": "13963" }
    ]
  },
  "ZA": {
    "country_code": "ZA",
    "languages": [
      { "language_code": "af", "language_id": "13959" },
      { "language_code": "en", "language_id": "11703" },
      { "language_code": "zu", "language_id": "14064" },
      { "language_code": "xh", "language_id": "14061" }
    ]
  },
  "KR": {
    "country_code": "KR",
    "languages": [
      { "language_code": "ko", "language_id": "14005" }
    ]
  },
  "SS": {
    "country_code": "SS",
    "languages": [
      { "language_code": "en", "language_id": "11703" }
    ]
  },
  "ES": {
    "country_code": "ES",
    "languages": [
      { "language_code": "es", "language_id": "13981" }
    ]
  },
  "LK": {
    "country_code": "LK",
    "languages": [
      { "language_code": "si", "language_id": "14036" },
      { "language_code": "ta", "language_id": "14047" }
    ]
  },
  "SD": {
    "country_code": "SD",
    "languages": [
      { "language_code": "ar", "language_id": "13963" },
      { "language_code": "en", "language_id": "11703" }
    ]
  },
  "SR": {
    "country_code": "SR",
    "languages": [
      { "language_code": "nl", "language_id": "14022" }
    ]
  },
  "SE": {
    "country_code": "SE",
    "languages": [
      { "language_code": "sv", "language_id": "14045" }
    ]
  },
  "CH": {
    "country_code": "CH",
    "languages": [
      { "language_code": "de", "language_id": "13977" },
      { "language_code": "fr", "language_id": "13987" },
      { "language_code": "it", "language_id": "14000" },
      { "language_code": "rm", "language_id": "14030" }
    ]
  },
  "SY": {
    "country_code": "SY",
    "languages": [
      { "language_code": "ar", "language_id": "13963" }
    ]
  },
  "TJ": {
    "country_code": "TJ",
    "languages": [
      { "language_code": "tg", "language_id": "14049" }
    ]
  },
  "TZ": {
    "country_code": "TZ",
    "languages": [
      { "language_code": "sw", "language_id": "14046" },
      { "language_code": "en", "language_id": "11703" }
    ]
  },
  "TH": {
    "country_code": "TH",
    "languages": [
      { "language_code": "th", "language_id": "14050" }
    ]
  },
  "TL": {
    "country_code": "TL",
    "languages": [
      { "language_code": "tet", "language_id": "14048" },
      { "language_code": "pt", "language_id": "14028" }
    ]
  },
  "TG": {
    "country_code": "TG",
    "languages": [
      { "language_code": "fr", "language_id": "13987" }
    ]
  },
  "TO": {
    "country_code": "TO",
    "languages": [
      { "language_code": "to", "language_id": "14054" },
      { "language_code": "en", "language_id": "11703" }
    ]
  },
  "TT": {
    "country_code": "TT",
    "languages": [
      { "language_code": "en", "language_id": "11703" }
    ]
  },
  "TN": {
    "country_code": "TN",
    "languages": [
      { "language_code": "ar", "language_id": "13963" }
    ]
  },
  "TR": {
    "country_code": "TR",
    "languages": [
      { "language_code": "tr", "language_id": "14056" }
    ]
  },
  "TM": {
    "country_code": "TM",
    "languages": [
      { "language_code": "tk", "language_id": "14052" }
    ]
  },
  "TV": {
    "country_code": "TV",
    "languages": [
      { "language_code": "tvl", "language_id": "14057" },
      { "language_code": "en", "language_id": "11703" }
    ]
  },
  "UG": {
    "country_code": "UG",
    "languages": [
      { "language_code": "en", "language_id": "11703" },
      { "language_code": "sw", "language_id": "14046" }
    ]
  },
  "UA": {
    "country_code": "UA",
    "languages": [
      { "language_code": "uk", "language_id": "14058" }
    ]
  },
  "AE": {
    "country_code": "AE",
    "languages": [
      { "language_code": "ar", "language_id": "13963" }
    ]
  },
  "GB": {
    "country_code": "GB",
    "languages": [
      { "language_code": "en", "language_id": "11703" }
    ]
  },
  "US": {
    "country_code": "US",
    "languages": [
      { "language_code": "en", "language_id": "11703" }
    ]
  },
  "UY": {
    "country_code": "UY",
    "languages": [
      { "language_code": "es", "language_id": "13981" }
    ]
  },
  "UZ": {
    "country_code": "UZ",
    "languages": [
      { "language_code": "uz", "language_id": "14060" }
    ]
  },
  "VU": {
    "country_code": "VU",
    "languages": [
      { "language_code": "bi", "language_id": "13969" },
      { "language_code": "en", "language_id": "11703" },
      { "language_code": "fr", "language_id": "13987" }
    ]
  },
  "VE": {
    "country_code": "VE",
    "languages": [
      { "language_code": "es", "language_id": "13981" }
    ]
  },
  "VN": {
    "country_code": "VN",
    "languages": [
      { "language_code": "vi", "language_id": "1" }
    ]
  },
  "YE": {
    "country_code": "YE",
    "languages": [
      { "language_code": "ar", "language_id": "13963" }
    ]
  },
  "ZM": {
    "country_code": "ZM",
    "languages": [
      { "language_code": "en", "language_id": "11703" }
    ]
  },
  "ZW": {
    "country_code": "ZW",
    "languages": [
      { "language_code": "en", "language_id": "11703" }
    ]
  }
}; 